const seoConfig = Object.freeze({
    siteName: 'Xprt Dev',
    siteUrl: 'https://xprt.dev/',
    language: 'en-AU',
    locale: 'en_AU',
    imageUrl: 'https://xprt.dev/icons/icon-512x512.png',
    imageAlt: 'Xprt Dev logo'
});

export default seoConfig;
